import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫漫画网`}
          title={`${comic.title} - 韩漫完整在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          width="400"
          height="560"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
            comic.status === "已完结"
              ? "bg-accent-500 text-background-50"
              : "bg-primary-500 text-background-50"
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-semibold px-2 py-0.5 rounded-md whitespace-nowrap">
          {comic.rating}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line mr-1"></i>
            {comic.views >= 10000
              ? `${(comic.views / 10000).toFixed(1)}万`
              : comic.views}
          </span>
          <span className="text-xs text-foreground-400">{comic.updateDate}</span>
        </div>
      </div>
    </Link>
  );
}